import {
  AbsoluteCenter,
  Box,
  chakra,
  Checkbox,
  Flex,
  Image,
  shouldForwardProp
} from '@chakra-ui/react';
import { isValidMotionProp, motion } from 'framer-motion';
import { COMMON_WEB_PATH } from '../../../../constant';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTransferInGameHandler } from './transferInGameHandler';
import i18next from 'i18next';
import CommonConfirmButton from '@/components/Common/CommonConfirmButton';
import CommonModal from '@/components/Common/CommonModal';

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop)
});

/**
 * @description 遊戲中轉點Modal
 * @param {function} onClose - 關閉Modal的函數
 * @returns
 */
const TransferInGameModal = ({ onClose } = {}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const { handleTransferAllIn } = useTransferInGameHandler();

  const [isChecked, setIsChecked] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleChecked = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleConfirm = async () => {
    if (!isChecked) return;

    setButtonLoading(true);

    await handleTransferAllIn({
      handleCancel,
      setButtonLoading
    });
  };

  const handleCancel = async () => {
    onClose();
  };

  return (
    <CommonModal onConfirm={handleCancel}>
      <Box
        flex={1}
        alignItems={'center'}
        fontSize="24px"
        fontWeight={'bold'}
        color="white"
        textAlign="center"
        display="flex"
        mb={2}
      >
        {i18n(
          '1.轉點期間請勿投注。若失敗將自動重試，無法成功時會將點數退回您的錢包'
        )}
        <br />
        {i18n('2.遊戲裡面的餘額若為0，入鈔成功後必須重新進入遊戲')}
      </Box>
      <CommonConfirmButton
        onClick={handleConfirm}
        _hover={{ filter: 'brightness(1.1)' }}
      />
      <Checkbox
        colorScheme="purple"
        size="lg"
        onChange={handleChecked}
        zIndex={3}
        sx={{
          background:
            'linear-gradient(180deg, #fff 0%,#fdd26a 60%,  #b07f20 80%,  #b07f20 100%)',
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          color: 'transparent',
          textShadow: '0px 1px 3px rgba(255, 215, 0, 0.4)',
          fontSize: '20px',
          fontWeight: 700
        }}
      >
        {i18n('我瞭解了')}
      </Checkbox>
    </CommonModal>
  );
};

export default TransferInGameModal;
